// Infinite horizontal ticker. Content is duplicated so the loop is seamless.
export default function Marquee({ items, className = "" }) {
  const row = (key) => (
    <div key={key} className="marquee-row" aria-hidden={key === "b"}>
      {items.map((t, i) => (
        <span key={i} className="marquee-item">
          {t}
          <span className="marquee-dot">✦</span>
        </span>
      ))}
    </div>
  );
  return (
    <div className={`marquee ${className}`}>
      <div className="marquee-track">{row("a")}{row("b")}</div>
    </div>
  );
}
